<template>
	<!-- 活动详情 -->
	<div>
		<div class="" v-show="$route.meta.showFather&& this.$route.fullPath =='/activity/activityDetail'">
			<div class="pad-16 mb-16 box-shadow" style="margin-top: 1rem;">
				<div class="is-flex mb-16">
					<div class="left-icon"></div>
					<p class="left-p">精彩活动</p>
					<span class="name-2" style="padding-left: 10px;">各类活动大咖汇集</span>
				</div>
				<div class="is-flex" style="align-items: flex-start">
					<div class="hed-img">
						<img :src="details.coverImage" alt="" style="width: 533px;height: 320px;border-radius: 4px;">
					</div>
					<div class="is-flex pd-tb" style="">
						<div>
							<div class="is-flex mb-8">
								<p class="name-1">{{details.name}}</p>
								<!-- details.activityStatus -->

								<p class="act-status"
									:class="details.activityStatus==1000?'act-status-1':details.activityStatus==2000?'act-status-2':'act-status-3'">
									{{details.activityStatus==1000?'待开始':details.activityStatus==2000?'进行中':'已结束'}}
								</p>

								<!-- <img :src="item.img" alt="" class="sex-img"> -->
								<!-- <img src="/src/assets/expert/nv.png" alt=""> -->
								<!-- <img src="../../assets/head/Frame 2333.png" alt="" class="sex-img"> -->
							</div>
							<div class="is-flex mb-8">
								<p class="name-2">活动时间:</p>
								<p class="name-3">
									{{utils.getNowTime(details.startTime)}}-{{utils.getNowTimes(details.endTime)}}
								</p>
							</div>
							<p class="money-1">¥&nbsp;{{details.price}}</p>
							<p class="baoming" v-show="details.eventStatus" @click="info(details.id,1)">报名信息
							</p>
							<p class="baoming" v-show="details.activityStatus!=3000&&!details.eventStatus"
								@click="quily(details.id)">立即报名</p>
							<!-- <div class="is-flex mb-8">
                                <p class="name-2">擅长领域:</p>
                                <p class="name-3">数学教学；课堂教学；</p>
                            </div> -->
						</div>
					</div>

				</div>

			</div>
			<div class="is-flex flex-tab mb-16">
				<p v-for="(item,index) in tpData" :key="index" tabindex="1" @click="systemChange(item,index)"
					:class="selectedIndex == index ? 'p-active':''">
					{{item.name}}
				</p>
				<!-- <p>活动简介</p>
                <p>活动详情</p>
                <p>联系方式</p>
                <p>专家介绍</p> -->
			</div>
			<div class="pad-16 mb-16 box-shadow" id="bayId1" v-if="details.introStatus">
				<div class="is-flex mb-16">
					<div class="left-icon"></div>
					<p class="left-p">活动简介</p>
				</div>
				<div class="is-flex mb-16">
					<p class="name-2">活动地点:</p>
					<p class="name-3">
						{{details.location}}
					</p>
				</div>
				<div class="is-flex align-base">
					<p class="name-2">活动简介:</p>
					<p class="name-3">
						{{details.intro}}
					</p>
				</div>
			</div>
			<div class="pad-16 mb-16 box-shadow" id="bayId2" v-if="details.contentStatus">
				<div class="is-flex mb-16">
					<div class="left-icon"></div>
					<p class="left-p">活动详情</p>
				</div>
				<div class="ql-editor">
					<div style="margin-top: 24px;" v-html="details.content"></div>
				</div>
			</div>
			<div class="pad-16 mb-16 box-shadow" id="bayId3" v-if="details.contactStatus">
				<div class="is-flex mb-16">
					<div class="left-icon"></div>
					<p class="left-p">联系方式</p>
				</div>
				<div class="is-flex jus-bet align-base">
					<div class="is-flex">
						<p class="name-2">联系电话:</p>
						<p class="name-3">
							{{details.phone}}
						</p>
					</div>
					<div class="is-flex">
						<p class="name-2">联系邮箱:</p>
						<p class="name-3">
							{{details.email}}
						</p>
					</div>
					<div class="is-flex align-base">
						<p class="name-2">联系微信:</p>
						<img :src="details.wechatQrCode" alt="" style="width: 88px;height: 88px;">
					</div>

				</div>
			</div>
			<div class="pad-16 mb-16 box-shadow" id="bayId4" v-if="details.expertIntroStatus">
				<div class="is-flex mb-16">
					<div class="left-icon"></div>
					<p class="left-p">专家介绍</p>
				</div>
				<div>
					<img :src="item" alt="" style="width: 100%;height: 20vw;" v-for="(item,index) in details.expertImage"
						:key="index">
				</div>
			</div>
			<div class="pad-16 mb-16 box-shadow" id="bayId5" v-if="details.linkStatus&&details.eventStatus">
				<div class="is-flex mb-16">
					<div class="left-icon"></div>
					<p class="left-p">活动链接</p>
				</div>
				<div style="font-size: 14px;color: #222222;margin-bottom: 10px;">
					<span style="color: #999999;margin-right: 20px;">活动地点:</span><el-link type="primary" @click="goLink(details.link)">{{details.link}}</el-link>
				</div>
				<div style="font-size: 14px;color: #222222;">
					<span style="color: #999999;margin-right: 20px;">链接说明:</span>详情介绍详情介，绍详情介绍详情介绍详，情介绍详情介绍详情介，绍详情介绍详情介绍详情介绍介。
				</div>
			</div>
			<div class="is-flex jus-bet" style="margin-top: 4rem;">
				<div></div>
				<el-button type="primary" v-show="details.activityStatus!=3000&&!details.eventStatus"
					@click="quily(details.id,1)">立即报名</el-button>
				<el-button type="primary" v-show="details.eventStatus" @click="info(details.id,1)">报名信息</el-button>
				<div></div>
			</div>
		</div>
		<router-view></router-view>
		<!-- <footers></footers> -->
	</div>
</template>

<script>
	import headView from '@/views/headView.vue';
	import footers from '@/views/footers.vue';
	import Breadcrumb from '@/views/Breadcrumb.vue';
	import {
		getActivityDetail,
	} from '@/api/activity/api.js';
	export default {
		components: {
			headView,
			footers,
			Breadcrumb
		},
		data() {
			return {
				infoShow: false,
				tpData: [{
						name: '活动简介',
						id: 'bayId1',
					},
					{
						name: '活动详情',
						id: 'bayId2',
					},
					{
						name: '联系方式',
						id: 'bayId3',
					},
					{
						name: '专家介绍',
						id: 'bayId4',
					},
					// {
					// 	name: '活动链接',
					// 	id: 'bayId5',
					// }
				],
				selectedIndex: 0,
				details: '',
				ids: ''
			}
		},
		created() {
			// console.log(this.ids,'22')
			// if(this.ids == ''){

			// }

		},
		mounted() {
			this.ids = this.$route.params.id;
			if (this.ids !== undefined) {
				// console.log(this.ids,'111')
				this.getDeatils(this.ids);
				localStorage.setItem('ids', this.ids)
			} else {
				this.ids = localStorage.getItem('ids');
				// console.log(this.ids,'22')
				this.getDeatils(this.ids);
			}
		},
		methods: {
			goLink(link){
				window.open(link);
			},
			getDeatils(id) {
				getActivityDetail({
						id: id
					}).then(res => {
						this.tpData.forEach((item, index) => {
							if (!res.data.introStatus && item.name == '活动简介') {
								this.tpData.splice(index, 1);
							}
						})
						this.tpData.forEach((item, index) => {
							if (!res.data.contentStatus && item.name == '活动详情') {
								this.tpData.splice(index, 1);
							}
						})
						this.tpData.forEach((item, index) => {
							if (!res.data.contactStatus && item.name == '联系方式') {
								this.tpData.splice(index, 1);
							}
						})
						this.tpData.forEach((item, index) => {
							if (!res.data.expertIntroStatus && item.name == '专家介绍') {
								this.tpData.splice(index, 1);
							}
						})
						// this.tpData.forEach((item, index) => {
						// 	if (!res.data.linkStatus && item.name == '活动链接') {
						// 		this.tpData.splice(index, 1);
						// 	}
						// })
						if (res.data.expertImage) {
							res.data.expertImage = res.data.expertImage.split(',');
						}
						this.details = res.data;
					})
					.catch(error => {

					});
			},
			// 报名信息
			info(id, num) {
				this.$router.push({
					name: 'information',
					params: {
						id: id,
						num: num
					}
				})
				// this.$router.push('/activity/information')
			},
			quily(id) {
				let token = localStorage.getItem('keyToken');
				if (!token) return this.$message({
					message: '账号暂未登录',
					type: 'warning'
				});
				this.$router.push({
					name: 'information',
					params: {
						id: id
					}
				})
				// this.$router.push('/activity/information')
			},
			systemChange(val, index) {
				this.selectedIndex = index;
				const targetElement = document.getElementById(val.id);
				if (targetElement) {
					// 将页面滚动到目标位置
					window.scrollTo({
						top: targetElement.offsetTop,
						behavior: 'smooth' // 平滑滚动效果
					});
				} else {
					console.error("未找到目标元素");
				}
			},
		}
	}
</script>


<style scoped>
	.pad-16 {
		padding: 16px;

	}

	.box-shadow {
		box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
	}

	.is-flex {
		display: flex;
		align-items: center;
	}

	.jus-bet {
		justify-content: space-between;
	}

	.hed-img {
		width: 533px;
		height: 320px;
		/* width: 47%; */
		/* height: auto; */
		/* width: 36rem;
        height: 20rem; */
		padding-right: 2rem;
	}

	.name-1 {
		font-size: 20px;
		padding-right: 1rem;
		white-space: nowrap;
	}

	.name-2 {
		color: #999999;
		font-size: 14px;
		white-space: nowrap;
		padding-right: 8px;
	}

	.name-3 {
		color: #222222;
		font-size: 14px;
		font-weight: normal;
	}


	.mb-8 {
		margin-bottom: 8px;
	}

	.mb-24 {
		margin-bottom: 24px;
	}

	.flex-tab {
		border-radius: 8px;
	}

	.flex-tab p {
		width: 25%;
		color: #666666;
		font-size: 14px;
		text-align: center;
		padding: 16px 0;
		background: #FAFAFA;
		cursor: pointer;
	}

	.flex-tab .p-active {
		background: #3377FF;
		color: #FFFFFF;
	}

	.flex-tab p:first-child {
		border-radius: 0.5rem 0 0 0.5rem;
	}

	.flex-tab p:last-child {
		border-radius: 0 0.5rem 0.5rem 0;
	}

	.mb-16 {
		margin-bottom: 16px;
	}

	.left-icon {
		width: 6px;
		height: 20px;
		background: #3377FF;
		border-radius: 18px;
	}

	.left-p {
		font-size: 20px;
		color: #222222;
		font-weight: normal;
		padding-left: 10px;
	}

	.align-base {
		align-items: flex-start;
	}

	.baoming {
		width: 25%;
		/* min-width: 20%; */
		text-align: center;
		padding: 12px 24px;
		background: #3377FF;
		border-radius: 8px 8px 8px 8px;
		font-size: 14px;
		font-weight: normal;
		color: #FFFFFF;
		white-space: nowrap;
	}

	.money-1 {
		padding: 4.5rem 0 1.5rem 0;
		color: #FF5533;
		font-weight: normal;
		line-height: 33px;
		font-size: 28px;
	}

	.act-status {
		border-radius: 4px 16px 4px 16px;
		padding: 4px 16px;
		font-size: 14px;
		white-space: nowrap;
	}

	.act-status-1 {
		color: #FBB54C;
		background: #FFF6F0;
	}

	.act-status-2 {
		color: #3ECC64;
		background: #EBFAEF;
	}

	.act-status-3 {
		color: #FF534D;
		background: #FFF0F0;
	}

	/deep/.el-button--primary {
		background-color: #3377FF;
		border-radius: 4px;
		padding: 0.75rem 3.625rem;
	}

	/deep/.el-button--primary span {
		font-size: 16px;
		color: #ffffff;
		text-align: center;
	}

	.pd-tb {
		padding: 2% 0;
	}

	/* 分辨率为1600*1200时 */
	@media (max-width: 1600px) {
		.money-1 {
			padding: 2.5rem 0 1.5rem 0;
		}

		.pd-tb {
			padding: 1.3125rem 0;
		}
	}

	/* 分辨率为1440x1050时 */
	@media (max-width: 1440px) {
		.money-1 {
			padding: 2rem 0 1.5rem 0;
		}

		.pd-tb {
			padding: 0.3125rem 0;
		}
	}

	/* 分辨率为1280*854时 */
	@media (max-width: 1280px) {}
</style>